import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-12-01.
 */

export class BenjiKIVScatterTriggeredRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;

    public shouldRun():boolean {
        return (BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || BenjiKIV.model.sfsIsMoreScatter
        );
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline();
        //If restore = true, the correct no of scatters has already been activated
        if(BenjiKIV.model.isRestore == false) {
            this._mainTL.add(gsap.timeline({delay : this.getActivateOverlaysDelay()}));
            this._mainTL.add(BenjiKIV.overlayScatterView.activateAllScatters());
        }
        this._mainTL.add(() => {controller.finish()}, "+=0.5");
    }

    private getActivateOverlaysDelay():number {
        return 0.6;
    }
}